export default "__VITE_ASSET__CyfP9z3V__"